import { useEffect } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "@/styles/cookie-consent.css";
import { startCookieConsent } from "@/lib/startCookieConsent";

/** Always mounted. The banner itself stays hidden once a choice is stored. */
export function CookieConsentBanner() {
    useEffect(() => {
        void startCookieConsent();
    }, []);
    return null;
}
